/*
 * Shared chart helpers for the bar charts (WeeklyBars / DailyBars).
 */

// Compact axis tick: 254246 → "254.2k", 1_500_000 → "1.5M", 850 → "850".
// `+(...).toFixed(1)` drops a trailing ".0" so round values read clean
// (5000 → "5k", not "5.0k"). Negative-safe via Math.abs on the threshold.
export function formatAxisTick(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1e6) return `${+(n / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${+(n / 1e3).toFixed(1)}k`;
  return String(n);
}

// Shared tick label style — mono, faint, small. Kept here so both charts
// stay visually identical when one is tweaked.
export const AXIS_TICK = { fill: 'var(--ink-faint)', fontSize: 10, fontFamily: 'var(--mono)' } as const;

/*
 * "Natural" categorical palette — muted, earthy tones for stacked charts with
 * many series (e.g. coupons / players per day per brand). Assigned by index so
 * segments stay distinguishable without the clashing raw brand colours (some
 * of which are near-black / near-white / duplicated). 16 hues, well separated;
 * with more series than this the palette repeats (adjacent segments still
 * differ since repeats are 16 apart).
 */
export const NATURAL_PALETTE = [
  '#6b8e5a', // moss
  '#c17f59', // terracotta
  '#d4a843', // ochre
  '#5b7b8a', // slate blue
  '#a8616a', // clay rose
  '#7a9b76', // sage
  '#b58a4c', // camel
  '#8c6f8e', // muted plum
  '#4f8a7b', // teal green
  '#c2925b', // sand
  '#6d8aa0', // dusty blue
  '#9caf63', // olive
  '#a86f4c', // rust
  '#7e9b9e', // stone teal
  '#bf9b6f', // wheat
  '#86756a', // taupe
] as const;

/** Pick a natural palette colour by index (wraps). */
export function naturalColor(i: number): string {
  return NATURAL_PALETTE[i % NATURAL_PALETTE.length];
}
